import { useState } from "react";
import PortfolioList from "./portfolio/PortfolioList";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface PortfolioProps {
  userId: string;
  isEditing?: boolean;
  onComplete?: () => void;
}

const Portfolio = ({ userId, isEditing = false, onComplete }: PortfolioProps) => {
  const [bgColor, setBgColor] = useState("#ffffff");
  const { toast } = useToast();

  const handleColorChange = async (color: string) => {
    try {
      const { error } = await supabase
        .from('profiles')
        .update({ 
          physical_attributes: {
            portfolio_background: color
          }
        })
        .eq('id', userId);

      if (error) throw error;

      setBgColor(color);
      toast({
        title: "Success",
        description: "Portfolio background color updated",
      });
    } catch (error) {
      console.error('Error updating background color:', error);
      toast({
        title: "Error",
        description: "Failed to update background color",
        variant: "destructive",
      });
    }
  };

  return (
    <div 
      style={{ backgroundColor: bgColor, transition: 'background-color 0.3s ease' }} 
      className="p-4 min-h-screen"
    >
      {isEditing && (
        <div className="flex justify-center mb-6 px-4 sm:px-6 lg:px-8">
          <Button 
            onClick={() => {
              const createProjectBtn = document.querySelector('[data-create-project]');
              if (createProjectBtn instanceof HTMLButtonElement) {
                createProjectBtn.click();
              }
            }}
            className="w-full max-w-md bg-gradient-to-r from-primary/90 to-primary hover:from-primary hover:to-primary/90 transition-all duration-300 shadow-lg hover:shadow-xl rounded-lg py-2.5"
            size="lg"
          >
            <Plus className="w-5 h-5 mr-2" />
            Adiciona mais Projectos
          </Button>
        </div>
      )}
      <div className="max-w-7xl mx-auto">
        <PortfolioList userId={userId} isEditing={isEditing} onComplete={onComplete} />
      </div>
    </div>
  );
};

export default Portfolio;